var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHierarchyDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.57892 17.0533H5.68419V14.2112H1.89473V17.0533H0V12.3164H7.57892V17.0533Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 17.0533H16.1053V14.2112H12.3158V17.0533H10.4211V12.3164H18V17.0533Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1578 13.2642H13.2631V10.4221H4.73682V13.2642H2.84209V8.52734H15.1578V13.2642Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.94742 6.63477H8.05269V9.4769H9.94742V6.63477Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7367 6.63154H4.26306V0.947266H13.7367V6.63154ZM6.15779 4.73678H11.842V2.84202H6.15779V4.73678Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHierarchyDark);
export default __webpack_public_path__ + "static/media/hierarchy-dark.749ce1afcb9ebca8b3f23a569af8b6a0.svg";
export { ForwardRef as ReactComponent };